import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";
import ReactQuill from "react-quill-new";
import { Link, useParams } from "react-router-dom";
import { addFollowUpMessageApi, createEmailTemplate, createPackageApi, createShipmentTypeDurationApi, createShippingAPi, getFollowUpsDataApi, getPackageSizeApi } from "../../apiHelper/authService";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearSelectedFollowUp, clearSelectedPackage, clearSelectedShipDuration } from "../../redux/authModalSlice";
import { changeEnquiryStatusApi } from "../../apiHelper/authService";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Icon } from "@iconify/react/dist/iconify.js";
const AddFollowUp = () => {
    const navigate = useNavigate()
    const [imagePreview, setImagePreview] = useState(null);
    const { selectedFollowUp } = useSelector((state) => state.authModal);
    const { user } = useSelector((state) => state.authModal);
    const fromCountry = user?.from;
    const toCountry = user?.to;
    const [shipDurId, setShipDurId] = useState('')

    // console.log("sad",selectedShipDuration)

    const quillRef = useRef(null);
    const [value, setValue] = useState(``);
    // eslint-disable-next-line no-unused-vars
    const [isHighlightReady, setIsHighlightReady] = useState(false);
    const dispatch = useDispatch()

    useEffect(() => {
        // Load highlight.js configuration and signal when ready
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);

    // eslint-disable-next-line no-unused-vars
    const handleSave = () => {
        const editorContent = quillRef.current.getEditor().root.innerHTML;
        console.log("Editor content:", editorContent);
    };

    // Quill editor modules with syntax highlighting (only load if highlight.js is ready)
    const modules = isHighlightReady
        ? {
            syntax: {
                highlight: (text) => hljs?.highlightAuto(text).value, // Enable highlight.js in Quill
            },
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        }
        : {
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        };

    const formats = [
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "color",
        "background",
        "script",
        "header",
        "blockquote",
        "code-block",
        "list",
        "indent",
        "direction",
        "align",
        "link",
        "image",
        "video",
        "formula",
    ];

    const [followUps, setFollowUps] = useState([])


    const [duration, setDuration] = useState('');
    const [locCharges, setLocCharges] = useState('');
    const [taxes, setTaxes] = useState('');
    const [sizeHeight, setSizeHeight] = useState('');
    const [sizeWeight, setSizeWeight] = useState('');
    const [discount, setDiscount] = useState('');
    const [loading, setLoading] = useState(false)

    const [desc, setDesc] = useState("")

    const [selectedUnit, setSelectedUnit] = useState("");


    const [subject, setSubject] = useState('');






    // const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    const [packageId, setPackageId] = useState(''); // can be generated or user-input
    const [mailImage, setMailImage] = useState(null);
    //   const [imagePreview, setImagePreview] = useState(null);

    //   const quillRef = useRef();
    const [imageName, setImageName] = useState('');

    const [ShipmentCharges, setShipmentCharges] = useState([]);



    // const getPackageSizes = async () => {
    //     setLoading(true);



    //     const toastId = toast.loading("Fetching Email Templates...");

    //     try {
    //         const data = await getPackageSizeApi();
    //         console.log(data)
    //         setShipmentCharges(data?.shipmentCharges || []);

    //         // setCategories(data);
    //         // setPackageData(data)
    //         toast.success("Email Templates fetched successfully!", { id: toastId });
    //     } catch (err) {
    //         console.error("Fetch Error:", err);

    //         toast.error(
    //             err?.message || "Something went wrong while fetching email templates.",
    //             { id: toastId }
    //         );
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // console.log(ShipmentCharges)


    // useEffect(() => {

    //     getPackageSizes()


    // }, [])




    const handleSubmit = async (e) => {
        e.preventDefault();


        const payloadData = {
            vendor_id: "",
            description: desc,
            shipment_enquiry_id: selectedFollowUp?.id





        }

        try {
            const res = await addFollowUpMessageApi(payloadData);
            console.log('Success:', res);
            toast.success(res.message || "Success")
            setDesc("")
            getFollowUps()
            // navigate("/shipment-duration")


        } catch (err) {
            toast.error(err || "Something went wrong")

            console.error('Error:', err);
        }


    };


    const changeStatus = async (newStatus) => {



        const payloadData = {
            full_name: selectedFollowUp?.full_name,
            mobile_number: selectedFollowUp.mobile_number,
            country_code: selectedFollowUp?.country_code,
            message: selectedFollowUp?.message,
            approx_package_weight: selectedFollowUp?.approx_package_weight,
            approx_package_length: selectedFollowUp?.approx_package_length,
            approx_package_width: selectedFollowUp?.approx_package_width,
            approx_package_height: selectedFollowUp?.approx_package_height,
            user_id: selectedFollowUp?.user_id,
            package_type:selectedFollowUp?.package_type,

            id: selectedFollowUp?.id,
            status: newStatus || selectedUnit



        }

        try {
            const res = await changeEnquiryStatusApi(payloadData);
            console.log('Status Updated:', res);
            toast.success("Status Updated")
            // setDesc("")
            // navigate("/shipment-duration")


        } catch (err) {
            toast.error(err || "Something went wrong")

            console.error('Error:', err);
        }


    };




    useEffect(() => {
        if (selectedFollowUp) {


            setSelectedUnit(selectedFollowUp?.status || '')







        }

        return () => {

            dispatch(clearSelectedFollowUp());
        };
    }, [selectedFollowUp, dispatch]);

    console.log(selectedFollowUp)



    const handleStatusChange = (value) => {
        setSelectedUnit(value);
        changeStatus(value); // trigger the API call on change
    };

    const statusOptions = [
        { label: "PENDING", value: "PENDING" },
        { label: "WORK IN PROGRESS", value: "WORK_IN_PROGRESS" },
        { label: "RESOLVED", value: "RESOLVED" },
        { label: "CLOSED", value: "CLOSED" },
    ];


    const getFollowUps = async () => {

        if (!selectedFollowUp) {
            return
        }



        setLoading(true);



        // const toastId = toast.loading("Fetching Follow Ups...");

        try {
            const data = await getFollowUpsDataApi({shipment_enquiry_id:selectedFollowUp?.id});
            setFollowUps(data)

            // toast.success("Follow Ups fetched successfully!", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err?.message || "Something went wrong.",
                // { id: toastId }
            );
        } finally {
            setLoading(false);
        }
    };


    useEffect(()=>{


        getFollowUps()



    },

    []

    )
  function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }


    console.log(followUps)
    return (
        <div className='row gy-4'>
            <div className='col-lg-12'>
                <div className='card mt-24'>
                    <div className='card-header border-bottom'>
                        <h6 className='text-xl mb-0'>Enquiry Details</h6>
                    </div>
                    <div className='card-body p-24'>
                        <form onSubmit={handleSubmit} className='d-flex flex-column gap-20'>
                            {/* Enquiry Message */}
                            <div className="card border border-neutral-200 rounded-3 mb-4">
                                <div className="card-body">
                                    <h5 className="fw-semibold mb-3 text-neutral-900 text-xl">Enquiry Message</h5>
                                    <p className="mb-0 text-neutral-700">{selectedFollowUp?.message}</p>
                                </div>
                            </div>

                            {/* User Details Card */}
                            <div className="card border border-neutral-200 rounded-3 mb-4">
                                <div className="card-body">
                                    <h5 className="fw-semibold mb-3 text-neutral-900 text-xl">User Details</h5>
                                    <div className="row">
                                        <div className="col-md-4 mb-3 ">
                                            <strong className="d-block text-neutral-700">Full Name:</strong>
                                            <span className="text-dark">{selectedFollowUp?.full_name}</span>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <strong className="d-block text-neutral-700">Email:</strong>
                                            <span className="text-dark">{selectedFollowUp?.user?.email}</span>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <strong className="d-block text-neutral-700">Mobile Number:</strong>
                                            <span className="text-dark">{selectedFollowUp?.mobile_number}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-md-6 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='desc'>
                                        Follow-up message
                                    </label>
                                    <textarea
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='desc'
                                        placeholder='Enter follow-up message here...'
                                        rows={4}
                                        value={desc}
                                        onChange={(e) => setDesc(e.target.value)}
                                    />
                                </div>

                                {/* <div className="col-md-6 col-12">

                                    <label className='form-label fw-bold text-neutral-900' htmlFor='sizeName'>

                                        Shipment Type
                                    </label>

                                    <div className="dropdown">
                                        <button
                                            className="btn btn-primary-600 bg-primary-50 border-primary-50 text-primary-600 hover-text-primary not-active px-18 py-11 dropdown-toggle toggle-icon"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {selectedUnit}
                                        </button>

                                        <ul className="dropdown-menu">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                    onClick={() => setSelectedUnit("AIR")}
                                                >
                                                    AIR
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"

                                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                    onClick={() => setSelectedUnit("SHIP")}
                                                >
                                                    SHIP
                                                </button>
                                            </li>
                                        </ul>
                                    </div>

                                </div> */}

                                <div className="col-md-6 col-12">

                                    <label className='form-label fw-bold text-neutral-900' htmlFor='sizeName'>


                                        Change Enquiry Status
                                    </label>

                                    < div className="dropdown">
                                        <button
                                            className="btn btn-primary-600 bg-primary-50 border-primary-50 text-primary-600 hover-text-primary not-active px-18 py-11 dropdown-toggle toggle-icon"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {
                                                statusOptions.find(option => option.value === selectedUnit)?.label ||
                                                "Change Status"
                                            }
                                        </button>

                                        <ul className="dropdown-menu">
                                            {statusOptions.map((option) => (
                                                <li key={option.value}>
                                                    <button
                                                        type="button"
                                                        className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                        onClick={() => handleStatusChange(option.value)}
                                                    >
                                                        {option.label}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                </div>


                            </div>















                            <button type='submit' className='btn btn-primary-600 radius-8 col-md-2'>
                                Add Follow Up Message
                            </button>
                        </form>


                        <div className="card basic-data-table mt-16">

                            <div className="card-header d-flex flex-row justify-content-between align-items-center">
                                <h5 className="card-title mb-0">Follow-ups</h5>

                                
                                


                            </div>

                            <div className="card-body">
                                <table
                                    className="table bordered-table mb-0"
                                    id="dataTable"

                                >
                                    <thead>
                                        <tr>

                                            <th scope="col">Follow-up Note</th>
                                            <th scope="col">			Added By</th>

                                            <th scope="col">	Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {followUps?.length > 0 ? (


                                            followUps?.map((followUpInfo) => (
                                                <tr key={followUpInfo.id}>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <h6 className="text-md mb-0 fw-medium flex-grow-1">
                                                                {followUpInfo.description} 
                                                            </h6>
                                                        </div>
                                                    </td>





                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <h6 className="text-md mb-0 fw-medium flex-grow-1">
                                                                {/* {shipInfo.duration} DAYS */}
                                                                admin
                                                            </h6>
                                                        </div>
                                                    </td>










                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <h6 className="text-md mb-0 fw-medium flex-grow-1">
                                                                {/* {shipInfo.duration} DAYS */}
                                                                {formatDate(followUpInfo?.createdAt)}
                                                            </h6>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))


                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center py-16 text-muted">
                                                    No Duration found.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>

                                </table>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Sidebar Start */}

        </div>
    );
};

export default AddFollowUp;
